import {isNotEmptyString} from "../../util/StringUtils"
import {compareDates, filterMapByKey, isEmailValid} from "../../atUtils"
import {GROUP_NEW_OR_NOT_KNOWN, ValidationErrors} from "./constants"

export class ErrorProcessor {
    constructor(errors = [], abortAfterFirstError = true) {
        this.errors = errors;
        this._valid = true;
        this.abortAfterFirstError = abortAfterFirstError
    }

    processError(processedError, checkIsValid) {
        this.errors = filterMapByKey(this.errors, processedError)

        if (this.abortAfterFirstError && !this._valid) {
            return this;
        }

        let isValid = checkIsValid()
        if (!isValid) this.errors = {...this.errors, [processedError]: true}
        this._valid = isValid;
        return this;
    }

    getErrorState() {
        return {
            errors: this.errors,
            isValid: this._valid
        }
    }
}

export function validateFirstName(errors, firstName) {
    return new ErrorProcessor(errors)
        .processError(ValidationErrors.FIRST_NAME_EMPTY, () => isNotEmptyString(firstName))
        .getErrorState();
}

export function validateLastName(errors, lastName) {
    return new ErrorProcessor(errors)
        .processError(ValidationErrors.LAST_NAME_EMPTY, () => isNotEmptyString(lastName))
        .getErrorState();
}

export function validateUserName(errors, username) {
    return new ErrorProcessor(errors)
        .processError(ValidationErrors.USERNAME_EMPTY, () => isNotEmptyString(username))
        .getErrorState();
}

export function validateEmail(errors, email, forCreate = false, backupEmail) {
    return new ErrorProcessor(errors)
        .processError(ValidationErrors.EMAIL_WAS_EMPTY, () => forCreate || !(email.length === 0 && backupEmail.length === 0))
        .processError(ValidationErrors.EMAIL_EMPTY, () => isNotEmptyString(email))
        .processError(ValidationErrors.EMAIL_INVALID, () => isEmailValid(email))
        .getErrorState();
}

export function validateUserGroupName(errors, ugrId, ugrName) {
    return new ErrorProcessor(errors)
        .processError(ValidationErrors.NEW_USER_GROUP_EMPTY, () => ugrId !== GROUP_NEW_OR_NOT_KNOWN || isNotEmptyString(ugrName))
        .getErrorState();
}

export function validateTimezoneGroup(errors, tzgId, tzg) {
    return new ErrorProcessor(errors, false)
        .processError(ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY, () => tzgId !== GROUP_NEW_OR_NOT_KNOWN || (tzg && isNotEmptyString(tzg.name)))
        .processError(ValidationErrors.CITY_DATA_EMPTY, () => tzgId !== GROUP_NEW_OR_NOT_KNOWN || (tzg && !!tzg.cityPlaceId))
        .getErrorState();
}

export function validateHireDate(errors, isEditHimself, hireDate) {
    return new ErrorProcessor(errors)
        .processError(ValidationErrors.HIRE_DATE_EMPTY, () => hireDate !== null)
        .processError(ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF, () => !isEditHimself || compareDates(hireDate, window.currentUserTime()) <= 0)
        .getErrorState();
}

export function validatePassword(errors, password) {
    return new ErrorProcessor(errors)
        .processError(ValidationErrors.PASSWORD_EMPTY, () => isNotEmptyString(password))
        .getErrorState()
}



// WEBPACK FOOTER //
// ./web/js/panels/user/validation.js